<template>
  <div id="videolist">
    <div class="article_box mainWidth">
      <div class="title">
        视频列表
    </div>
      <mu-row gutter>
        <mu-col class="news_videos"  v-for="videos in videos" :key="videos.videoimgurl" width="33" tablet="33" desktop="33">
          <div class="videos_box">
            <div class="videos_cover_box">
              <img :src="videos.videoimgurl" />
              <div class="mask">
                <div class="videos_play middle" @click="getVideo(videos.videoid)">

                </div>
              </div>
              <div class="videos_duration">

                <div class="videos_icon_clock">
                </div>
                <div class="videos_creattime">
                  {{videos.createtime}}
                  </div>
              </div>
            </div>
            <div class="videos_title">
              {{videos.title}}
              </div>
            <div class="videos_intro">
              {{videos.describes}}
              </div>
            <div class="videos_other">
              <div class="videos_time">
                {{videos.createtime}}
                </div>
              <div class="videos_playnumber">
                <span class="icon_view"></span>
                <span class="number">
                    {{videos.playnumber}}
                  </span>

              </div>
            </div>
          </div>
          <!--<comvideoplayer></comvideoplayer>-->
        </mu-col>
      </mu-row>
      <!--分页组件-->
      <div class="pagination_box"  v-if="total!=0">
        <mu-pagination :total="total" :current="current" :pageSize="pageSize" @pageChange="handleClick">
        </mu-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'article',
    data () {
      return {
        current: 1,
        pageIndex:1,
        pageSize:6,
        total:0,
        news:{}
      }
    },
    created(){
      this.id=this.$route.params.id||"1";
      this.reqVideoList();
    },
    methods:{
      getVideo(id){ //跳转到列表详情
        this.$router.push({name:"video",params:{id:id}});
      },
      handleClick(page){ //点击分页
        if(page!=this.pageIndex){
          this.pageIndex=page;
          this.reqVideoList();
        }
      },
      reqVideoList(){ //请求文章列表
        this.$http({
          root:'http://www.supershooter.cn:8099/webapi/video',
          method:'post',
          params:{
            pageIndex:this.pageIndex,
            pageSize:this.pageSize
          }
        }).then((res)=>{
          this.sw=true;
          if(res.body.code==200){
            this.videos=res.body.data;
            this.total=res.body.count;
          }else{
            this.showErr(res);
          }
        },(res)=>{
          this.showErr(res);
        });
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #videolist{
    background-color: #E6E6E6;
    overflow:hidden;
    clear:both;
    .article_box{
      margin-top:16px;
      margin-bottom:60px;
      background:#fff;
      padding:22px 55px;
      min-height:640px;
      .title{
        font-family: PingFangSC-Medium;
        display:inline-block;
        height:80px;
        padding:0px 4px;
        font-size: 16px;
        color: #3B3B3B;
        letter-spacing: 0;
        line-height: 80px;
        border-top:4px solid #2095D4;
        font-weight:600;
      }
    }
    .news_videos{
      margin-bottom:10px;
    }
    .videos_box{
      width:100%;
      height:auto;
      overflow:hidden;
      position:relative;
      background: #FFFFFF;
      transition:all 500ms;
      border-radius: 2px;
      &:hover{
        box-shadow: 0 8px 10px 0 rgba(0,0,0,0.09);
      }
      .videos_cover_box{
        position:relative;
        width:inherit;
        height:258px;
        overflow:hidden;
        >img{
          width:100%;
          height:auto;
        }
        .mask{
          position:absolute;
          top:0;
          left:0;
          width:inherit;
          height:inherit;
          background-color:rgba(0,0,0,0.3);
          .videos_play{
            width:62px;
            height:62px;
            background:url("../assets/images/play.png") no-repeat center center;
            background-size:100% 100%;
            cursor:pointer;
          }
        }
      }
      .videos_duration{
        position:absolute;
        background:rgba(0,0,0,0.3);
        border-radius: 100px;
        right:10px;
        bottom:10px;
        font-size: 12px;
        color: #FFFFFF;
        letter-spacing: 0;
        padding:9px 20px;
        height:36px;
        .videos_icon_clock{
          width:18px;
          height:18px;
          bakcground:blue;
          float:left;
          background:url("../assets/images/clock.png") no-repeat center center;
          background-size:100% 100%;
          margin-right:5px;
        }
        .videos_creattime{
          float:left;
          font-size: 12px;
          color: #FFFFFF;
          letter-spacing: 0;
        }
      }
      .videos_title{
        font-size: 18px;
        color: #21A1E5;
        letter-spacing: 0;
        line-height: 16px;
        font-weight:600;
        padding:20px 16px;
        line-height:24px;
        min-height:24px;
      }
      .videos_intro{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #9398A1;
        letter-spacing: 0;
        line-height: 20px;
        padding:0px 16px;
        min-height:40px;
      }
      .videos_other{
        height:15px;
        line-height:15px;
        font-size: 12px;
        color: #B5BAC4;
        letter-spacing: 0;
        padding:0px 16px;
        margin-bottom:15px;
        .videos_time{
          float:left;
        }
        .videos_playnumber{
          float:right;
          display:block;
          height:15px;
          line-height:15px;
          .icon_view{
            display:inline-block;
            width:20px;
            height:15px;
            background: url("../assets/images/eye.png") no-repeat center center;
            background-size:100% 100%;
            float:left;
          }
          .number{
            display:block;
            height:15px;
            line-height:16px;
            width:50px;
            padding-left:10px;
            float:left;
          }

        }
      }
    }
    .pagination_box{
      height:auto;
      margin: 0 auto;
      text-align:center;
    }
  }

</style>




// WEBPACK FOOTER //
// src/page/videolist.vue